import "./../../styles/dashboard.css";
import StarRating from "../star-rating/star-rating";
import { BsFillCartCheckFill, BsCartXFill } from "react-icons/bs";
import { FaChevronRight } from "react-icons/fa";

const AccountSection = ({ title, accounts, selectedCategory, setSelectedCategory, navigate }) => {
  const activeAccounts = accounts?.filter(
    (acc) => acc.product_status === "active"
  );

  return (
    <section className="account-section-container">
      <div className="account-category">
        <div className="category-title-container">
          <h2 className="category-title">{title}</h2>
        </div>
        <div className="account-category-container">
          <AccountCategory value={"latest"} title={"Mới nhất"} selected={selectedCategory} onClick={() => setSelectedCategory("latest")}/>
          <AccountCategory value={"pinned"} title={"Sản phẩm hot"} selected={selectedCategory} onClick={() => setSelectedCategory("pinned")}/>
          {/* <AccountCategory value={"recommend"} title={"Gợi ý cho bạn"} selected={selectedCategory} onClick={() => setSelectedCategory("recommend")} /> */}
          <AccountCategory value={"under_1m"} title={"Tài khoản dưới 1 triệu"} selected={selectedCategory} onClick={() => setSelectedCategory("under_1m")} />
          <AccountCategory value={"under_5h"} title={"Tài khoản dưới 500k"} selected={selectedCategory} onClick={() => setSelectedCategory("under_5h")}/>
        </div>
        <div className="account-info-container">
          {activeAccounts?.map((acc) => (
            <AccountCard key={acc._id} acc={acc}></AccountCard>
          ))}
        </div>
        <div className="view-all-button-wrapper">
          <div onClick={() => navigate('/category/game-account')} className="view-all-button">
            <p>Xem tất cả</p>
            <FaChevronRight className="right-view-all-icon" />
          </div>
        </div>
      </div>
    </section>
  );
};

const AccountCategory = ({title, onClick, selected, value}) => {
  return (
    <div onClick={onClick} className={`category-button-container ${selected === value && "selected-account-category-option"}`}>
      <p>{title }</p>
    </div>
  )
}

export const AccountCard = ({ acc }) => {
  return (
    <a
      href={`/product/${acc?.product_slug}`}
      className="account-item-container"
    >
      <img
        loading="lazy"
        className="account-item-image"
        src={acc?.product_imgs[0]}
        alt="product-img"
      />
      <div className="account-item-info">
        <p className="item-name">{acc?.product_name}</p>
        <div className="order-type-price-container">
          <div className="order-type-container">
            <BsFillCartCheckFill className="account-item-order-icon" />
            {/* {acc?.product_stock > 0 ? (
              <BsFillCartCheckFill className="account-item-order-icon" />
            ) : (
              <BsCartXFill className="account-item-order-icon" />
            )} */}
            {/* <p
              className={`available-text ${
                acc?.product_stock > 0 ? "product-stock" : "product-sold"
              }`}
            >
              {acc?.product_stock > 0 ? "Còn hàng" : "Hết hàng"}
            </p> */}
            <p
              className={`available-text product-stock`}
            >
              Còn hàng
            </p>
          </div>
          <div className="item-price">
            <p>{acc?.product_attributes?.price.toLocaleString()}đ</p>
          </div>
        </div>
        <div className="rating-sold-container">
          <StarRating rating={acc?.averageRating} />
          <p className="sold-text">Đã bán {acc?.product_sold_amount}</p>
        </div>
      </div>
    </a>
  );
};

export default AccountSection;
